import React from 'react';
import { EnvelopeIcon, ChatBubbleLeftIcon } from '@heroicons/react/24/outline';

interface TemplateTypeBadgeProps {
  type: 'email' | 'sms';
  size?: 'sm' | 'md' | 'lg';
  showIcon?: boolean;
}

export const TemplateTypeBadge: React.FC<TemplateTypeBadgeProps> = ({
  type,
  size = 'md',
  showIcon = true,
}) => {
  const sizeClasses = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-2.5 py-0.5 text-xs',
    lg: 'px-3 py-1 text-sm',
  };

  const iconSizes = {
    sm: 'w-3 h-3',
    md: 'w-3 h-3',
    lg: 'w-4 h-4',
  };

  if (type === 'email') {
    return (
      <span
        className={`inline-flex items-center rounded-full font-medium bg-blue-100 text-blue-800 ${sizeClasses[size]}`}
      >
        {showIcon && <EnvelopeIcon className={`${iconSizes[size]} mr-1`} />}
        Email
      </span>
    );
  }

  return (
    <span
      className={`inline-flex items-center rounded-full font-medium bg-purple-100 text-purple-800 ${sizeClasses[size]}`}
    >
      {showIcon && <ChatBubbleLeftIcon className={`${iconSizes[size]} mr-1`} />}
      SMS
    </span>
  );
};

